/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SamPolicyFormPersonsResponseDtoDto } from '../models/sam-policy-form-persons-response-dto-dto';
import { SamPolicyFormRequestDtoDto } from '../models/sam-policy-form-request-dto-dto';
import { SamPolicyFormResponseDtoDto } from '../models/sam-policy-form-response-dto-dto';
import { SamPolicyFormsResponseDtoDto } from '../models/sam-policy-forms-response-dto-dto';


/**
 * the PolicyForm API
 */
@Injectable({
  providedIn: 'root',
})
export class PolicyFormService extends BaseService {
  constructor(
    config: SalesApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation updateFormsData
   */
  static readonly UpdateFormsDataPath = '/policy/{offerID}/forms';

  /**
   * Update forms data for policy
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFormsData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormsData$Response(params: {
    offerID: string;
    'X-Authorization'?: string;
    body: SamPolicyFormRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SamPolicyFormResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, PolicyFormService.UpdateFormsDataPath, 'put');
    if (params) {
      rb.path('offerID', params.offerID, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SamPolicyFormResponseDtoDto>;
      })
    );
  }

  /**
   * Update forms data for policy
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFormsData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormsData(params: {
    offerID: string;
    'X-Authorization'?: string;
    body: SamPolicyFormRequestDtoDto
  },
  context?: HttpContext

): Observable<SamPolicyFormResponseDtoDto> {

    return this.updateFormsData$Response(params,context).pipe(
      map((r: StrictHttpResponse<SamPolicyFormResponseDtoDto>) => r.body as SamPolicyFormResponseDtoDto)
    );
  }

  /**
   * Path part for operation storeFormsData
   */
  static readonly StoreFormsDataPath = '/policy/{offerID}/forms';

  /**
   * Store forms data for policy
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeFormsData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeFormsData$Response(params: {
    offerID: string;
    'X-Authorization'?: string;
    body: SamPolicyFormRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SamPolicyFormResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, PolicyFormService.StoreFormsDataPath, 'post');
    if (params) {
      rb.path('offerID', params.offerID, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SamPolicyFormResponseDtoDto>;
      })
    );
  }

  /**
   * Store forms data for policy
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeFormsData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeFormsData(params: {
    offerID: string;
    'X-Authorization'?: string;
    body: SamPolicyFormRequestDtoDto
  },
  context?: HttpContext

): Observable<SamPolicyFormResponseDtoDto> {

    return this.storeFormsData$Response(params,context).pipe(
      map((r: StrictHttpResponse<SamPolicyFormResponseDtoDto>) => r.body as SamPolicyFormResponseDtoDto)
    );
  }

  /**
   * Path part for operation deleteFormsData
   */
  static readonly DeleteFormsDataPath = '/policy/{offerID}/forms';

  /**
   * Delete all forms stored for the policy
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFormsData()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFormsData$Response(params: {
    offerID: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PolicyFormService.DeleteFormsDataPath, 'delete');
    if (params) {
      rb.path('offerID', params.offerID, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete all forms stored for the policy
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFormsData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFormsData(params: {
    offerID: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteFormsData$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getPolicyForms
   */
  static readonly GetPolicyFormsPath = '/forms';

  /**
   * Get forms
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPolicyForms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPolicyForms$Response(params?: {
    'X-Authorization'?: string;
    productCode?: string;
    offerID?: string;
    variantCode?: string;
    roleType?: string;
    formCode?: string;
    languages?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SamPolicyFormsResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, PolicyFormService.GetPolicyFormsPath, 'get');
    if (params) {
      rb.header('X-Authorization', params['X-Authorization'], {});
      rb.query('productCode', params.productCode, {});
      rb.query('offerID', params.offerID, {});
      rb.query('variantCode', params.variantCode, {});
      rb.query('roleType', params.roleType, {});
      rb.query('formCode', params.formCode, {});
      rb.query('languages', params.languages, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SamPolicyFormsResponseDtoDto>;
      })
    );
  }

  /**
   * Get forms
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPolicyForms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPolicyForms(params?: {
    'X-Authorization'?: string;
    productCode?: string;
    offerID?: string;
    variantCode?: string;
    roleType?: string;
    formCode?: string;
    languages?: Array<string>;
  },
  context?: HttpContext

): Observable<SamPolicyFormsResponseDtoDto> {

    return this.getPolicyForms$Response(params,context).pipe(
      map((r: StrictHttpResponse<SamPolicyFormsResponseDtoDto>) => r.body as SamPolicyFormsResponseDtoDto)
    );
  }

  /**
   * Path part for operation getPolicyFormsPersons
   */
  static readonly GetPolicyFormsPersonsPath = '/forms/{offerID}/person';

  /**
   * Get persons for forms
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPolicyFormsPersons()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPolicyFormsPersons$Response(params: {
    offerID: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SamPolicyFormPersonsResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, PolicyFormService.GetPolicyFormsPersonsPath, 'get');
    if (params) {
      rb.path('offerID', params.offerID, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SamPolicyFormPersonsResponseDtoDto>;
      })
    );
  }

  /**
   * Get persons for forms
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPolicyFormsPersons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPolicyFormsPersons(params: {
    offerID: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<SamPolicyFormPersonsResponseDtoDto> {

    return this.getPolicyFormsPersons$Response(params,context).pipe(
      map((r: StrictHttpResponse<SamPolicyFormPersonsResponseDtoDto>) => r.body as SamPolicyFormPersonsResponseDtoDto)
    );
  }

}
